import AdtInfoDisplayLangSelect from "./adtInfoDisplayLangSelect.container";

export default AdtInfoDisplayLangSelect;